import { useState, useEffect } from "react";
import ReportRevenueBoard from "./ReportRevenueBoard";
import { DatePicker, Pagination, Select, message, ConfigProvider } from "antd";
import { ITEM_WISE_SALES_REPORT_SORTBY, PAGINATION_PAGE_OPTIONS } from "../../../constant/constants";
import ReportTable from "./ReportTable";
import dayjs from "dayjs";
import { isDate1GreaterThanDate2 } from "../../../utils/Common";
import useUserStore from "../../../stores/store";

export default function ItemWiseSalesReportComponent({
  reportData,
  categories,
  setItemWiseSalesFilter,
  handleFilterApply,
  page,
  perPage,
  setPerPage,
  total,
  handlePageChange,
  setIsFilterClear,
  handleDownload,
  loading,
}) {
  const { showNotification } = useUserStore();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [sortBy, setSortBy] = useState("");

  useEffect(() => {
    setItemWiseSalesFilter((prev) => ({
      ...prev,
      fromDate,
      toDate,
      categoryId,
      sortBy,
      page,
      perPage,
    }));
  }, [fromDate, toDate, categoryId, sortBy, page, perPage]);

  function onHandleFromDate(date, dateString) {
    if (isDate1GreaterThanDate2(dateString, toDate)) {
      showNotification("From Date cannot be greater than To Date.");
      return;
    }
    setFromDate(dateString);
  }

  function onHandleToDate(date, dateString) {
    if (date) {
      if (fromDate != "" && !(new Date(dateString) >= new Date(fromDate))) {
        message.warning("This date must be grater than from date.");
        return;
      }
      setToDate(dateString);
    } else {
      setToDate("");
    }
  }

  function onHandleCategory(value) {
    setCategoryId(value);
  }

  function onHandleSortBy(value) {
    setSortBy(value);
  }

  function onHandleClearFilter() {
    setIsFilterClear(true);
    setFromDate("");
    setToDate("");
    setCategoryId("");
    setSortBy("");
    setItemWiseSalesFilter((prev) => ({
      restaurantId: prev.restaurantId,
      page: 1,
      perPage: 10,
    }));
  }

  return (
    <section>
      {/* revenue board */}
      <ReportRevenueBoard data={reportData} context="item-wise-sales" handleDownload={handleDownload} />

      {/* filters */}
      <ConfigProvider
        theme={{
          components: {
            DatePicker: {
              zIndexPopup: 1,
            },
            Select: {
              zIndexPopup: 1,
            },
          },
        }}
      >
        <div className="flex items-center space-between w-full mt-[20px] mb-[31px]">
          <div className="flex items-center space-x-[15px] items-center w-full">
            <div className="h-[48px] w-[18.285714286%]">
              <DatePicker
                className={"h-full w-full"}
                showTime={false}
                onChange={onHandleFromDate}
                placeholder="From Date"
                value={fromDate ? dayjs(fromDate) : null}
                disabledDate={(current) => current && current > dayjs().endOf("day")}
              />
            </div>
            <div className="h-[48px] w-[18.285714286%]">
              <DatePicker
                className={"h-full w-full"}
                showTime={false}
                onChange={onHandleToDate}
                placeholder="To Date"
                value={toDate ? dayjs(toDate) : null}
                disabledDate={(current) => {
                  if (!fromDate) {
                    return current && current > dayjs().endOf("day");
                  }
                  return (current && current < dayjs(fromDate).startOf("day")) || current > dayjs().endOf("day");
                }}
              />
            </div>
            <div className="h-[48px] w-[24.285714286%]">
              <Select
                className="w-full h-full"
                showSearch={false}
                onChange={onHandleCategory}
                placeholder="Category"
                optionFilterProp="label"
                options={categories}
                value={categoryId || null}
              />
            </div>

            <div className="h-[48px] w-[22%] relative">
              <Select
                className="w-full h-full"
                showSearch={false}
                onChange={onHandleSortBy}
                placeholder="Sort By"
                optionFilterProp="label"
                options={ITEM_WISE_SALES_REPORT_SORTBY}
                value={sortBy || null}
              />
            </div>
          </div>
          <div className="h-[48px] w-[220px] flex items-center space-x-[20px]">
            <button
              className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px]"
              onClick={onHandleClearFilter}
            >
              Clear
            </button>
            <button
              className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px]"
              onClick={handleFilterApply}
            >
              Apply
            </button>
          </div>
        </div>
      </ConfigProvider>

      {/* sales report table */}
      <div>
        <ReportTable data={reportData} context={"item-wise-sales"} page={page} perPage={perPage} isLoading={loading} />
        <div className="mt-[20px] mb-[50px] report-pagination relative custom-pagination-options">
          <Pagination
            showSizeChanger
            onChange={handlePageChange}
            onShowSizeChange={(current, size) => {
              setPerPage(size);
            }}
            current={page}
            pageSize={perPage}
            total={total}
            pageSizeOptions={PAGINATION_PAGE_OPTIONS}
            locale={{ items_per_page: "" }}
            showQuickJumper={false}
          />

          <div
            className="absolute h-[48px] flex items-center space-x-[40px] 
          top-0 right-[122px] text-[18px] font-medium text-[#7D7D7D] mr-3"
          >
            <div>Total: {total}</div>
            <div>Row </div>
          </div>
        </div>
      </div>
    </section>
  );
}
